module.exports = __webpack_public_path__ + "img/20210828_213920.207697af.jpg";